import React, { useState, useEffect } from 'react';

// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';

import { Assignment, Visibility, Add } from '@material-ui/icons';
import Card from 'components/Card/Card';
import CardIcon from 'components/Card/CardIcon';
import CardHeader from 'components/Card/CardHeader';
import CardBody from 'components/Card/CardBody';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import Button from 'components/CustomButtons/Button.js';
import { wsFindBy } from 'services/WService';
import { Box } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { currency } from 'hooks/Pipe';
import { WithApp } from 'contexts/appContext';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
};
const useStyles = makeStyles(styles);

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 110 },
  { Header: 'Cód. Socio', accessor: 'CardCode', width: 120 },
  { Header: 'Nombre Socio', accessor: 'CardName' },
  { Header: 'RUC/DNI', accessor: 'LicTradNum', width: 120, align: 'center' },
  { Header: 'Saldo', accessor: 'Balance', width: 120, align: 'right' },
  { Header: 'Fec. Creado', accessor: 'CreateDate', width: 120, align: 'center' },
  { Header: 'Tér. Pago', accessor: 'PymntGroup', width: 120, align: 'center' },
  { Header: 'Estado', accessor: 'state', width: 120, align: 'center' },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 }
];

export default WithApp(function PendingPaymentSharedFile(props) {
  const classes = useStyles();

  const { title, entity, excelName, permission } = props;

  const [businessPartners, setBusinessPartners] = useState([]);

  const [dataLoading, setDataLoading] = useState(false);

  async function getBusinessPartners() {
    setDataLoading(true);
    let response = await wsFindBy(entity);
    setDataLoading(false);
    if (response.success) setBusinessPartners(response.data);
  }

  useEffect(() => {
    getBusinessPartners();
  }, []);

  return (
    <Card>
      <CardHeader icon>
        <AllowedGuard
          permission={permission}
          component={
            <CardIcon color={props.themeContext.buttonColor}>
              <Assignment style={{ color: 'white' }} />
            </CardIcon>
          }
        >
          <Link to={`0`}>
            <CardIcon pointer="true" color="success">
              <Add style={{ color: 'white' }} />
            </CardIcon>
          </Link>
        </AllowedGuard>
        <h4 className={classes.cardIconTitle}>{title}{dataLoading && <LoadingSpinner />}</h4>
      </CardHeader>
      <CardBody>
        <ReactTable
          excelName={excelName}
          heightRow={50}
          defaultWidth={1200}
          formatDate="DD-MM-YYYY"
          columns={columns}
          data={businessPartners.map((item, i) => {
            return {
              num: (
                <Box display="flex" alignItems="center">
                  {i + 1}
                  {item.id !== 0 ? (
                    <AllowedGuard permission={permission}>
                      <Button justIcon round simple>
                        <Link to={`${item.id}`}>
                          <Visibility />
                        </Link>
                      </Button>
                    </AllowedGuard>
                  ) : (
                    <Button
                      justIcon
                      round
                      simple
                      onClick={() =>
                        alert(
                          `El socio ${item.CardName}(${item.CardCode}) no esta registrado en el sistema comercial`,
                        )
                      }
                    >
                      <Visibility />
                    </Button>
                  )}
                </Box>
              ),
              CardCode: item.CardCode,
              CardName: item.CardName,
              LicTradNum: item.LicTradNum,
              Balance: currency(item.Balance),
              CreateDate: item.CreateDate,
              PymntGroup: item.PymntGroup,
              state: item.frozenFor === 'N' ? 'Activo' : 'Inactivo',
              actions: '',
            };
          })}
        />
      </CardBody>
    </Card>
  );
});
